export default {
    colors: {
      background: {
        primary: "#FFFFFF",
        secondary: "#FAFAFA",
        header: "#15408D",
        subHeader: "#143D86",
        dashboardBgc: "#F2F6FC",
        button: "#4277DB",
        field: "#F2F2F2",
      },
      textColor: {
        primary: "#000000",
        secondary: "#4A4A4A",
        ternary: "#FFFFFF",
        heading: "#15408D",
        subHeading: "#16428F",
        link: "#2F77C6",
        error: "#FF4646",
      },
      headingGradient: {
        primary: "#4079DA",
        secondary: "#20B260",
      },
    },
    fontFamily: {
      proxima: "Proxima",
      openSansR: "OpenSansRegular",
      openSansSB: "OpenSansSemibold",
      nutinoSansR: "NutinoSansRegular",
      overpassR: "OverpassRegular",
      overpassM: "OverpassMedium",
      overpassSB: "OverpassSemiBold",
      poppinsSB: "PoppinsSemiBold",
    },
    breakPoints: ["600px", "768px", "992px", "1200px"],
    fontSizes: [
      "12px",
      "13px",
      "14px",
      "15px",
      "16px",
      "17px",
      "18px",
      "24px",
      "26px",
      "38px",
    ],
    table: {
      "tableHeadBackground": "#F5FAFF",
      "tableHeadBorder": "#E3F0FD",
      "tableHeadText": "#0D4074",
      tableSelectedPage: "#618ACB",
    }
  };
  